import { DietaryPropertyKind } from '@sg/graphql-schema';

import { type DietaryRestrictionsTypes } from '../dietary-preferences.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export function generateInitialContext(): Context {
  return {
    restrictions: INITIAL_DIETARY_RESTRICTIONS,
    pendingRestrictions: INITIAL_DIETARY_RESTRICTIONS,
  };
}

// ─── Constants ───────────────────────────────────────────────────────────────

export const INITIAL_DIETARY_RESTRICTIONS: DietaryRestrictionsTypes = {
  [DietaryPropertyKind.Dairy]: false,
  [DietaryPropertyKind.Meat]: false,
  [DietaryPropertyKind.Nuts]: false,
  [DietaryPropertyKind.Gluten]: false,
  [DietaryPropertyKind.Fish]: false,
  [DietaryPropertyKind.Soy]: false,
};

// ─── Types ───────────────────────────────────────────────────────────────────

export type Context = {
  restrictions: DietaryRestrictionsTypes;
  pendingRestrictions: DietaryRestrictionsTypes;
};
